module.exports = __webpack_public_path__ + "img/feature_buy_id.14e10382.png";